import { render, staticRenderFns } from "./HostRoom.vue?vue&type=template&id=68226db4&scoped=true"
import script from "./HostRoom.vue?vue&type=script&lang=js"
export * from "./HostRoom.vue?vue&type=script&lang=js"
import style0 from "./HostRoom.vue?vue&type=style&index=0&id=68226db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68226db4",
  null
  
)

export default component.exports